import { useQuery } from "react-query";

import { useApiClient } from "api/useApiClient";

import type { SharedArgs } from "../schemas";

const getTherapistEnrolledPatientsQueryKey = (args: SharedArgs) =>
  ["getTherapistEnrolledPatients", args.params] as const;

export const useGetTherapistEnrolledPatients = (args: SharedArgs) => {
  const client = useApiClient();

  return useQuery(getTherapistEnrolledPatientsQueryKey(args), () => client.getTherapistEnrolledPatients(args));
};
